import { Box, Button, Grid, Typography } from '@material-ui/core'
import { Event } from '@material-ui/icons'
import Breadcrumb from 'components/common/Breadcrumb'
import SectionTitle from 'components/common/SectionTitle'
import { useLanguage } from 'context/Translation'
import { format } from 'date-fns'
import { observer } from 'mobx-react-lite'
import { FC, Fragment, useEffect } from 'react'
import { getUrlAdress } from 'utils'
import { useSanctionStyles } from '../Sanction/Sanctions.styles'
import HtmlElement from 'components/common/HtmlElement'
import Spiner from 'components/common/Spiner'
// import { useTranslation } from 'react-i18next'
import { sanctionsService } from 'services/sanctions/sanctions.service'
const SanctionImplementationsDetails: FC = () => {
  const classes = useSanctionStyles()
  const url = getUrlAdress(window.location.pathname)
  const id = url[url.length - 1].name
  const { language } = useLanguage()

  const { sanctionImplementationDetail, lang, loading } = sanctionsService

  useEffect(() => {
    if (id === null) return
    if (sanctionImplementationDetail.id !== Number(id)) {
      sanctionsService.fetchSanctionImplementationDetail(language, Number(id))
      return
    }
    if (lang !== language) {
      sanctionsService.fetchSanctionImplementationDetail(language, Number(id))
      return
    }
  }, [sanctionImplementationDetail, language, id])

  useEffect(() => {
    return function cleanupPage() {
      sanctionsService.cleanDetail()
    }
  }, [])

  if (loading) {
    return (
      <Fragment>
        <SectionTitle isEnd />
        <Box className={classes.container}>
          <Spiner />
        </Box>
      </Fragment>
    )
  }

  const TagsContent = (
    <Box width={'100%'}>
      <Grid container spacing={2} className={classes.tagContainer}>
        <Grid item className={classes.gridBox}>
          <Box className={classes.dateBox}>
            <Event className={classes.icon} />
            {sanctionImplementationDetail.date
              ? format(
                  new Date(sanctionImplementationDetail.date),
                  'dd.MM.yyyy'
                )
              : null}
          </Box>
        </Grid>
        <Grid item className={classes.gridBox}>
          <Box className={classes.countryName}>
            <Typography className={classes.name}> Страна:</Typography>

            <Typography className={classes.name}>
              {sanctionImplementationDetail.country}
            </Typography>
          </Box>
        </Grid>
        <Grid item className={classes.gridBox}>
          <Typography className={classes.name}> Объект санкций:</Typography>
          {sanctionImplementationDetail?.designation_type}
        </Grid>
      </Grid>
    </Box>
  )

  return (
    <Fragment>
      <SectionTitle isEnd isShown={false} />
      <Breadcrumb title="подробности" />
      <Box className={classes.container}>
        <Grid container direction="column">
          <Grid item xs container>
            <Grid item xs>
              <Box className={classes.headerBackground}>
                <Box className={`${classes.text} `}>
                  <Box className={classes.tagBox}>{TagsContent}</Box>
                </Box>
              </Box>
              {sanctionImplementationDetail.designation && (
                <Box className={`${classes.valueBox} ${classes.textMargin} `}>
                  <Typography className={classes.label}>
                    Название юридического лица / ФИО{' '}
                  </Typography>
                  <Typography className={classes.value}>
                    {sanctionImplementationDetail.designation}
                  </Typography>
                </Box>
              )}
              {sanctionImplementationDetail.justification && (
                <Box className={`${classes.valueBox} ${classes.textMargin} `}>
                  <Typography className={classes.label}>
                    Нормативно-правовое обоснование (рус.){' '}
                  </Typography>

                  <HtmlElement
                    component="div"
                    classes={`${classes.text} `}
                    html={sanctionImplementationDetail.justification}
                  />
                </Box>
              )}
              {sanctionImplementationDetail.justification_en && (
                <Box className={`${classes.valueBox} ${classes.textMargin} `}>
                  <Typography className={classes.label}>
                    Нормативно-правовое обоснование (англ.){' '}
                  </Typography>

                  <HtmlElement
                    component="div"
                    classes={`${classes.text} `}
                    html={sanctionImplementationDetail.justification_en}
                  />
                </Box>
              )}

              {sanctionImplementationDetail.reason && (
                <Box className={`${classes.comment} ${classes.textMargin} `}>
                  <Typography className={classes.name}>
                    {' '}
                    Причина внесения в санкционные списки
                  </Typography>

                  <HtmlElement
                    component="div"
                    classes={`${classes.text} `}
                    html={sanctionImplementationDetail.reason}
                  />
                </Box>
              )}

              {sanctionImplementationDetail.source?.length && (
                <Box className={`${classes.text} ${classes.textMargin}`}>
                  <a
                    href={sanctionImplementationDetail.source[0].value}
                    rel="noreferrer"
                    target="_blank"
                  >
                    <Button className={classes.linkButton}>
                      Ссылка на документ
                    </Button>
                  </a>
                </Box>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Fragment>
  )
}

export default observer(SanctionImplementationsDetails)
